module.exports = __webpack_public_path__ + "img/mobile_app_1.3a534eb8.png";